export default "__VITE_ASSET__CUB_mBcu__"